import { render, staticRenderFns } from "./Manuals.vue?vue&type=template&id=28ff3360&scoped=true"
import script from "./Manuals.vue?vue&type=script&lang=js"
export * from "./Manuals.vue?vue&type=script&lang=js"
import style0 from "./Manuals.vue?vue&type=style&index=0&id=28ff3360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ff3360",
  null
  
)

export default component.exports